module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "sub-tab-color",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md1": "",
      "md10": "",
      "pt-2": "",
      "pb-2": ""
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("\n      Olá, "), _c('strong', {
    staticClass: "captalize"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(", " + _vm._s(_vm.registrationStatusMessage) + "\n    ")]), _vm._v(" "), (_vm.status < 89) ? _c('span', {
    staticClass: "pull-right link cadastro-red",
    on: {
      "click": _vm.cadastro
    }
  }, [_vm._v("\n      Continuar o cadastro\n    ")]) : _vm._e(), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "28px",
      "margin-bottom": "8px"
    },
    attrs: {
      "color": "green",
      "background-color": "white"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43861c11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/inicio/RegisterStatus.vue
// module id = 749
// module chunks = 3